import Home from "../../domain/landingpage/components/Home";
import Products from "../../domain/landingpage/components/Products";
import Solutions from "../../domain/landingpage/components/Solutions";
import Prices from "../../domain/landingpage/components/Prices";

type LandingpageSection = "home" | "products" | "solutions" | "prices";

interface LandingpagePageProps {
  section: LandingpageSection;
}

export default function LandingpagePage({ section }: LandingpagePageProps) {
  switch (section) {
    case "products":
      return <Products />;
    case "solutions":
      return <Solutions />;
    case "prices":
      return <Prices />;
    case "home":
      return <Home />;
  }
}
